/**
 * A heading's words in title case as they have always been, plus the
 * store's sentence case, swapped by the ca_preview skin (aaa-seam.css).
 * Server-safe: no flag read, so the HTML is identical either way.
 */
import React from 'react';

export default function CaseSwap({ title, sentence }: { title: React.ReactNode; sentence: React.ReactNode }) {
  return (
    <>
      <span className="ca-tc">{title}</span>
      <span className="ca-sc hidden">{sentence}</span>
    </>
  );
}
